import * as React from 'react'

import * as styles from './ButtonLabel.module.less'

const activeDefault = false

export const ButtonLabel: React.FC<{
    active?: boolean
    onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
}> = (props) => {
    const { active: propsActive, children, onClick } = props
    const active = propsActive !== undefined ? propsActive : activeDefault

    const className = active
        ? `${styles.label} ${styles.labelActive}`
        : styles.label

    return (
        <a className={className} onClick={onClick}>
            {children}
        </a>
    )
}
